// extracted by mini-css-extract-plugin
export default {"card":"d3hssRkK","_showBorder":"JwGNnMZ2","desktop":"desktop","title":"vxPi4CW0","imageContainer":"R9vs51yp","overlay":"QLAF9M35","cardTextContent":"l5aTsIbH"};